/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl } from "react-intl";
import { Tabs } from "antd-mobile";
import { connect } from "react-redux";
import FavouriteButton from "../../components/FavouriteButton";
import DetailsSection from "./DetailsSection";
import ReviewSection from "./ReviewSection";
import * as foodAction from "../../actions/food";
import * as selectors from "../../selectors";
import * as foodSelectors from "../../selectors/food";
import Theme from "../../utils/Theme";
import "./index.css";

const StyledContainer = styled.div`
  background: #f4f4f4;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
`;

class ProductPage extends Component {
  constructor(props) {
    super(props);
    const { intl } = this.props;

    this.state = {
      animationClass: null,
      tabs: [
        {
          title: intl.formatMessage({
            id: "product.tab.details.title",
            defaultMessage: "Details",
            description: "Product Details Tab Title"
          })
        },
        {
          title: intl.formatMessage({
            id: "product.tab.review.title",
            defaultMessage: "Reviews",
            description: "Product Reviews Tab Title"
          })
        }
      ]
    };
  }

  componentDidMount() {
    this.configureNavBar();
    this.fetchFoodDetailItem();
    this.fetchFoodReviewData();
    this.setState({ animationClass: "slide-in-right" });
  }

  configureNavBar = (title = null, liked = false) => {
    const { navbarConfig, showTabbar, showNavbar } = this.props;
    const navTitle = title ? (
      title
    ) : (
      <span>
        <FormattedMessage id="app.loading" />
        ...
      </span>
    );

    navbarConfig(
      navTitle,
      null,
      <FavouriteButton
        liked={liked}
        onClicked={like =>
          this.onPressFavouriteItem(this.getCurrentFoodID(), like)
        }
      />,
      () => this.onBackPressed(),
      null
    );
    showNavbar(true);
    showTabbar(false);
  };

  onBackPressed = () => {
    const { history } = this.props;
    this.setState({ animationClass: "slide-out-right" });

    window.setTimeout(() => {
      history.goBack();
    }, 300);
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.foodDetailData !== nextProps.foodDetailData) {
      const foodTitle = foodSelectors.getFoodShortName(
        nextProps.foodDetailData
      );
      const foodIsFavourite = foodSelectors.getFoodIsFavourite(
        nextProps.foodDetailData
      );

      this.configureNavBar(foodTitle, foodIsFavourite);
    }
  }

  fetchFoodDetailItem = () => {
    const { getFoodDetailItemRequest } = this.props;
    const foodID = this.getCurrentFoodID();

    getFoodDetailItemRequest(foodID);
  };

  fetchFoodReviewData = page => {
    const { getFoodReviewListRequest } = this.props;
    const foodID = this.getCurrentFoodID();

    getFoodReviewListRequest(foodID, page);
  };

  getCurrentFoodID = () => {
    const { match } = this.props;
    return match && match.params ? match.params.id : null;
  };

  getReviewDataList = () => {
    const { foodReviewData } = this.props;
    const emptyData = [{ type: "empty" }];

    return foodReviewData && foodReviewData.length > 0
      ? foodReviewData
      : emptyData;
  };

  onStallReviewEndReached = () => {
    const {
      foodReviewPagination,
      match,
      getFoodReviewListRequest
    } = this.props;
    const stallID = match && match.params ? match.params.id : null;

    if (foodReviewPagination) {
      const { pageCount, currentPage } = foodReviewPagination;

      if (currentPage < pageCount) {
        getFoodReviewListRequest(stallID, currentPage + 1, true);
      }
    }
  };

  onPressFavouriteItem = (foodID, isFavourite) => {
    const {
      favouriteFoodRequest,
      unFavouriteFoodRequest,
      authToken,
      history
    } = this.props;

    if (!authToken) {
      history.push("/auth/login");
      return;
    }

    if (isFavourite) {
      favouriteFoodRequest(foodID);
    } else {
      unFavouriteFoodRequest(foodID);
    }
  };

  onPressWriteReview = () => {
    const { foodDetailData, history } = this.props;

    const reviewID = foodSelectors.getFoodReviewID(foodDetailData);
    history.push("/shop/review/" + reviewID);
  };

  onPressProductSelection = () => {
    const { foodDetailData, authToken, history } = this.props;

    if (!authToken) {
      history.push("/auth/login");
      return;
    }

    history.push("/shop/selection/" + foodDetailData.id);
  };

  render() {
    const { animationClass, tabs } = this.state;
    const {
      history,
      foodDetailData,
      foodDetailLoading,
      foodReviewLoading,
      foodReviewHideLoading
    } = this.props;
    const isReviewable = foodSelectors.getFoodIsReviewable(foodDetailData);

    return (
      <StyledContainer
        className={animationClass !== null ? animationClass : false}
        onAnimationEnd={() => this.setState({ animationClass: null })}
      >
        <Tabs
          tabs={tabs}
          initalPage={"details"}
          swipeable={false}
          tabBarUnderlineStyle={{
            height: "6px",
            backgroundColor: Theme.PrimaryColor,
            border: "unset"
          }}
          tabBarTextStyle={{
            fontSize: "1em"
          }}
          tabBarActiveTextColor={Theme.PrimaryColor}
          tabBarInactiveTextColor={"grey"}
          renderTabBar={props => <Tabs.DefaultTabBar {...props} />}
        >
          <DetailsSection
            item={foodDetailData}
            isLoading={foodDetailLoading}
            onItemAddToCart={this.onPressProductSelection}
            {...this.props}
          />
          <ReviewSection
            review={
              foodDetailData && foodDetailData.review
                ? foodDetailData.review
                : null
            }
            reviews={this.getReviewDataList()}
            isReviewable={isReviewable}
            isLoading={foodReviewLoading}
            hideLoading={foodReviewHideLoading}
            onEndReached={() => {
              this.onStallReviewEndReached();
            }}
            onPressWriteReview={this.onPressWriteReview}
            {...this.props}
          />
        </Tabs>
      </StyledContainer>
    );
  }
}

ProductPage.propTypes = {
  showNavbar: PropTypes.func.isRequired,
  showTabbar: PropTypes.func.isRequired,
  navbarConfig: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  intl: PropTypes.object,
  authToken: PropTypes.string,
  foodDetailData: PropTypes.object,
  foodDetailLoading: PropTypes.bool,
  foodReviewData: PropTypes.array,
  foodReviewPagination: PropTypes.object,
  foodReviewLoading: PropTypes.bool,
  foodReviewHideLoading: PropTypes.bool,
  getFoodDetailItemRequest: PropTypes.func,
  getFoodReviewListRequest: PropTypes.func,
  favouriteFoodRequest: PropTypes.func,
  unFavouriteFoodRequest: PropTypes.func
};

function mapStateToProps(state, props) {
  const { match } = props;
  const foodId = match && match.params ? match.params.id : null;

  return {
    authToken: selectors.getAuthToken(state),
    foodDetailData: selectors.getFoodDetailItem(state, foodId),
    foodDetailLoading: selectors.getFoodDetailLoading(state),
    foodReviewData: selectors.getFoodReviewListData(state, foodId),
    foodReviewPagination: selectors.getFoodReviewListPagination(state, foodId),
    foodReviewLoading: selectors.getFoodReviewLoading(state),
    foodReviewHideLoading: selectors.getFoodReviewHideLoading(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getFoodDetailItemRequest: foodID =>
      dispatch(foodAction.getFoodDetailItemRequest(foodID)),
    getFoodReviewListRequest: (foodID, page, hideLoading) =>
      dispatch(foodAction.getFoodReviewListRequest(foodID, page, hideLoading)),
    favouriteFoodRequest: foodID =>
      dispatch(foodAction.favouriteFoodRequest(foodID)),
    unFavouriteFoodRequest: foodID =>
      dispatch(foodAction.unFavouriteFoodRequest(foodID))
  };
}

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ProductPage)
);



// WEBPACK FOOTER //
// ./src/containers/ProductPage/index.js